module.exports = __webpack_public_path__ + "img/notFoundAvatar.eb84f74f.png";